import React, { ChangeEvent, FocusEvent, useState } from "react";
import styles from "./password.module.scss";

const PasswordField = ({
  label,
  id,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  autoComplete,
  className,
}) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="form-group">
      <label htmlFor="">{label}</label>
      <div
        className={`input-group ${isFocused ? "focused" : ""} ${
          styles.input_group
        }`}
      >
        <input
          type={passwordVisible ? "text" : "password"}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur && onBlur(e);
          }}
          onFocus={() => setIsFocused(true)}
          placeholder={placeholder}
          className={`${styles.input_pass} ${className}`}
          style={{
            borderRight: passwordVisible
              ? 0
              : isFocused
              ? "1px solid #6b66da"
              : "1px solid #f4f4f4",
          }}
          autoComplete="off"
        />
        {value && value.length > 0 && (
          <div
            className={`input-group-append ${
              isFocused ? styles.focused : ""
            } ${className}`}
          >
            <span
              className={styles.info}
              onClick={() => setPasswordVisible(!passwordVisible)}
            >
              {passwordVisible ? "Hide" : "Show"}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PasswordField;
